import React, { ReactNode } from 'react'
import { Redirect, Route } from 'router/compat'
import About, { tabIds } from 'about/ui/about'
import { CachedMarkupService } from 'markup/application/MarkupService'
import { sitemapDefaults } from 'router/sitemapConfig'
import { HeadTagsService } from 'router/head'
import NotFoundPage from 'NotFoundPage'
import { newsletters } from 'about/ui/news'

export default function AboutRoutes({
  sitemap,
  cachedMarkupService,
}: {
  sitemap: boolean
  cachedMarkupService: CachedMarkupService
}): JSX.Element[] {
  return [
    <Redirect
      exact
      from="/about/news"
      to={`/about/news/${newsletters[0].number}`}
      key="about-news-root-redirect"
    />,
    <Redirect
      exact
      from="/about/dictionary"
      to="/about/akkadian-dictionary"
      key="about-dictionary-redirect"
    />,
    <Redirect
      exact
      from="/news"
      to={`/about/news/${newsletters[0].number}`}
      key="news-root-redirect"
    />,
    ...newsletters.map((newsletter) => (
      <Redirect
        exact
        from={`/news/${newsletter.number}`}
        to={`/about/news/${newsletter.number}`}
        key={`news-redirect-${newsletter.number}`}
      />
    )),
    ...newsletters.map((newsletter) => (
      <Route
        key={`about-news-${newsletter.number}`}
        exact
        path={`/about/news/${newsletter.number}`}
        render={(): ReactNode => (
          <HeadTagsService
            title={`Newsletter #${newsletter.number} - eBL`}
            description={
              'Latest news and updates about the electronic Babylonian Library (eBL).'
            }
          >
            <About
              markupService={cachedMarkupService}
              activeTab="news"
              activeSection={newsletter.number.toString()}
            />
          </HeadTagsService>
        )}
        {...(sitemap && sitemapDefaults)}
      />
    )),
    ...tabIds
      .filter((tabId) => tabId !== 'news')
      .map((tabId) => (
        <Route
          key={`about-${tabId}`}
          exact
          path={`/about/${tabId}`}
          render={(): ReactNode => (
            <HeadTagsService
              title="About: eBL"
              description="This section provides detailed information about the electronic Babylonian Library (eBL) and the materials and tools available."
            >
              <About markupService={cachedMarkupService} activeTab={tabId} />
            </HeadTagsService>
          )}
          {...(sitemap && sitemapDefaults)}
        />
      )),
    <Redirect from="/about" to="/about/library" key="about-root-redirect" />,
    <Route
      key="AboutNotFound"
      path="/about/*"
      render={(): ReactNode => <NotFoundPage />}
    />,
  ]
}
